import { Controller } from "@hotwired/stimulus"
import { parseAmount, formatAmount } from "../lib/parse_amount"

// Formatiert einen Betrag auf zwei Nachkommastellen, sobald das Feld verlassen
// wird. Connects to data-controller="amount-field"
//
// Bewusst nur beim Verlassen und nie beim Tippen: Live-Formatierung während
// der Eingabe ist die Quelle der bekannten Ärgernisse -- der Cursor springt
// ans Ende, wenn man in der Mitte korrigiert, und aus einer angefangenen "12"
// wird sofort "12,00", sodass die Nachkommastellen nicht mehr eingebbar sind.
// Der System-Spec spec/system/amount_field_spec.rb hält das fest.
export default class extends Controller {
  format() {
    const value = this.element.value

    // Ein leeres Feld bleibt leer, statt eine Null zu erfinden.
    if (value.trim() === "") return

    const number = parseAmount(value)

    // Unlesbares bleibt stehen, sonst verliert der Nutzer seine Eingabe und
    // weiss nicht, was er falsch gemacht hat.
    if (number === null) return

    this.element.value = formatAmount(number)
  }
}
